import isMobile from 'is-mobile';

const getIsMobileDevice = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  if (window.isMobileDevice !== undefined) {
    return !!window.isMobileDevice;
  }

  const isCurrentMobileDevice = isMobile({
    tablet: true,
    featureDetect: true,
  });

  window.isMobileDevice = isCurrentMobileDevice;
  return isCurrentMobileDevice;
};

export const isMobileDevice = getIsMobileDevice();
